import { HttpClient } from './httpClient';
import { API_URL } from './RestAPI';
import apiHeaders from './apiHeaders';

const ShippingCarrier_API = `${API_URL}/fulfillment-centers`;

const getShippingCarriers = (fulfillmentCenterId) => {
  return HttpClient.get(
    `${ShippingCarrier_API}/${fulfillmentCenterId}/shipping-carriers`,
    apiHeaders()
  );
};

const createShippingCarrier = (fulfillmentCenterId, shippingCarrier) => {
  return HttpClient.post(
    `${ShippingCarrier_API}/${fulfillmentCenterId}/shipping-carriers`,
    shippingCarrier,
    apiHeaders()
  );
};

const updateShippingCarrier = (carrierId, shippingCarrier) => {
  return HttpClient.put(
    `${API_URL}/shipping-carriers/${carrierId}`,
    shippingCarrier,
    apiHeaders()
  );
};

const deleteShippingCarrier = (carrierId) => {
  return HttpClient.delete(
    `${API_URL}/shipping-carriers/${carrierId}`,
    apiHeaders()
  );
};

const ShippingCarrierAPI = { getShippingCarriers, createShippingCarrier, updateShippingCarrier, deleteShippingCarrier, };

export { ShippingCarrierAPI };
